<ng-container *ngIf="isPopupBlockedDialogOpened">
  <boi-confirmation-dialog
    class="vo-modal vo-modal--standard"
    [titleLabel]="referenceDataLabels.PopupBlockerWarningTitle"
    [confirmationLabel]="referenceDataLabels.PopupBlockerWarning"
    [confirmationButtonLabel]="referenceDataLabels.OkText"
    [(opened)]="isPopupBlockedDialogOpened"
    [hasWarning]="false"
    [hasCancelButton]="false"
  >
  </boi-confirmation-dialog>
</ng-container>

<ng-container *ngIf="isSessionAboutToExpireDialogOpened">
  <boi-session-about-to-expire-dialog
    class="vo-modal"
    [(opened)]="isSessionAboutToExpireDialogOpened"
    (confirmAction)="userSessionService.confirmConnectionToServer()"
  >
  </boi-session-about-to-expire-dialog>
</ng-container>

<ng-container *ngIf="isGdprPrivacyNoticeOpened">
  <boi-gdpr-privacy-notice-dialog
    class="vo-modal"
    [titleLabel]="referenceDataLabels.GdprModalTitle"
    [(opened)]="isGdprPrivacyNoticeOpened"
    [class.vo-modal--overlay-hidden]="isGdprDialogOpened"
    (openGdprDialog)="openGdprDialog()"
  >
  </boi-gdpr-privacy-notice-dialog>

  <ng-container *ngIf="isGdprDialogOpened">
    <boi-gdpr-dialog class="vo-modal vo-modal--large" [(opened)]="isGdprDialogOpened"></boi-gdpr-dialog>
  </ng-container>
</ng-container>
